export const menuData = [
  {
    title: "首页",
    path: "/home/index",
  },

  {
    title: "数据产品",
    path: "/tool",
    tagGroup: ["数据产品标签"],
  },
  {
    title: "数据服务",
    path: "/course",
    tagGroup: ["数据服务标签"],
  },
  {
    title: "数据交易",
    path: "/sjjypt",
    tagGroup: ["数据交易平台标签"],
    children: [
      {
        title: "典枢数据流通平台",
        path: "/dssjltpt",
        catalogType: "link",
        redirectUrl: "https://dianshudata.com/"
      },
      {
        title: "数据交易平台IDEX系统",
        path: "/idexxt",
        catalogType: "link",
        redirectUrl: "https://webs.bjidex.com/sys-bsc-home/#/bscConsole/tradingMarket/"
      },
    ],
  },
  {
    title: "场景共创",
    path: "/cjgc",
    tagGroup: ["场景共创标签"],
    children: [
      // {
      //   title: "AI应用场景共创",
      //   path: "/yycjgc",
      //   catalogType: "link",
      //   redirectUrl: "https://dianshudata.com/"
      // },
      {
        title: "AI聚合服务专区",
        path: "/jhfwzq",
        tagGroup: ["算力服务标签", "模型服务标签"],
      },
    ],
  },
  {
    title: "生态合作",
    path: "/case",
    tagGroup: ["生态合作标签"],

  },
  {
    title: "人才实训",
    path: "/alliance",
    tagGroup: ["人才实训标签"],
  },
  {
    title: "政策法规",
    path: "/tax",
    tagGroup: ["政策法规标签"],
  },
  {
    title: "专家智库",
    path: "/zjzk",
    tagGroup: ["资源侧", "流通侧", "价值侧", "金融侧"],
  },
  {
    title: "关于我们",
    path: "/gywm",
    children: [
      {
        title: "园区介绍",
        path: "/expert",
      },
      {
        title: "新闻动态",
        path: "/xwdt",
        tagGroup: ["新闻动态标签"],
      }, {
        title: "通知公告",
        path: "/tzgg",
        tagGroup: ["通知公告标签"],
      },]
  }
];
